// extracted by mini-css-extract-plugin
export default {"root":"_2RP7W","scrollable":"_3loqU","size-small":"RCJHE","sizeSmall":"RCJHE","size-medium":"UY_Hc","sizeMedium":"UY_Hc","tag-item":"_1fFrL","tagItem":"_1fFrL"};